import {SET_USUARIO, UsuarioActionTypes} from "../types/usuarioActionTypes";
import {IUsuario} from "../../entities/catalogos/IUsuario";

export function setUsuario(usuario: IUsuario): UsuarioActionTypes {
    return{
        type: SET_USUARIO,
        usuario
    }
}
